import { GAUGE_3_CLASSNAME } from 'components/gauge/gauge-3';
import { SCATTER_HISTORICAL_CHART_CLASSNAME } from 'features/patient/_components/symptom-card/components/graph-historical-scatterchart';
import { ConcussionAnalysis } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { CgsInventory } from 'features/patient/assessment/questionnaires/cgs/cgsSlice';
import { CRxPlotlyReference } from 'features/patient/patient-summary/components/crx-plotly-import';
import {
  getPlotlyConfigForConcussionComplexityProgression,
  getPlotlyConfigForTotalSymptomTracker
} from 'features/patient/patient-summary/components/displays/utils/plotly-configs';
import { brainFunctionVisualisations } from 'lib/utils/business/brainfunction-categories';
import { uniq } from 'lodash';
import { SERIALISE_CONCUSSION_COMPLEXITY_SCALE_CLASSNAME } from '../components/serialise-svg-component';
import { imageStoreKeyFactory } from './imageStoreKeyFactory';
import { saveSVGElement } from './saveElement';
import { UseImageStoreReturn } from './create-image-store';

export async function saveSVGs(
  imageStore: UseImageStoreReturn,
  rootElement: Element
) {
  const brainfunctionParentImageKeys = brainFunctionVisualisations.map(_ =>
    imageStoreKeyFactory.brainfunctionVisualisation(_)
  );
  await saveBrainFunctions(
    brainfunctionParentImageKeys,
    imageStore,
    rootElement
  );

  await saveSVG(
    imageStore,
    rootElement,
    `#${SERIALISE_CONCUSSION_COMPLEXITY_SCALE_CLASSNAME} svg`
  );
}

async function saveSVG(
  imageStore: UseImageStoreReturn,
  rootElement: Element,
  query: string
) {
  const concussionComplexityImage = await saveSVGElement(query, rootElement);
  imageStore.setImage(
    SERIALISE_CONCUSSION_COMPLEXITY_SCALE_CLASSNAME,
    concussionComplexityImage
  );
}

async function saveBrainFunctions(
  brainfunctionList: string[],
  imageStore: UseImageStoreReturn,
  rootElement: Element
) {
  const urls = await Promise.all(
    uniq(brainfunctionList).map(async elementId => {
      return {
        key: elementId,
        gauge: await saveSVGElement(
          `#${CSS.escape(elementId)} .${GAUGE_3_CLASSNAME}`,
          rootElement
        ),
        scatter: await saveSVGElement(
          `#${CSS.escape(elementId)} .${SCATTER_HISTORICAL_CHART_CLASSNAME}`,
          rootElement
        )
      };
    })
  );

  imageStore.setImages(
    urls.reduce(
      (acc, val) => ({
        ...acc,
        [[val.key, 'gauge'].join('-')]: val.gauge,
        [[val.key, 'scatter'].join('-')]: val.scatter
      }),
      {}
    )
  );
}
export async function saveGraphs(
  imageStore: UseImageStoreReturn,
  cgsData: CgsInventory[],
  concussionData: ConcussionAnalysis[]
) {
  await CRxPlotlyReference.toImage(
    getPlotlyConfigForTotalSymptomTracker(cgsData, 400),
    {
      format: 'jpeg',
      width: 500,
      height: 500
    }
  ).then(image =>
    imageStore.setImage('metrics-total-symptom-score-tracker', image)
  );

  await CRxPlotlyReference.toImage(
    getPlotlyConfigForConcussionComplexityProgression(
      concussionData ?? [],
      1000
    ),
    {
      format: 'jpeg',
      width: 500,
      height: 500
    }
  ).then(image =>
    imageStore.setImage('metrics-concussion-complexity-over-time', image)
  );
}
